<template>
  <div class="xinsheng-warp system-warp">
    <FilterForm
        :formData="filterData"
        :filters="filters"
        @submit="handleSubmit"
        @reset="handleReset"
    />
    <TheadedTable
        :tableColumn="tableColumn"
        :tableData="tableData"
        @nameDrawer="handleNameDrawer"
        :page="pagination.page"
        :size="pagination.size"
        @saveRowData="saveRowData"
    />
    <TheadedPagination
        :total="total"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
    />

    <CustomerDetail
        width="1200px"
        :isShowDialog="isShowDrawer"
        @close="handleDrawerClose"
        direction="rtl"
        :userId="drawerId"
    />
  </div>
</template>

<script>
import TheadedTable from "@/components/table";
import TheadedPagination from "@/components/pagination";
import { computed, onMounted, reactive, ref } from "vue";
import { tableColumn ,filters } from "./index.js";
import { useStore } from "vuex";
import { reset } from "@/until";
import CustomerDetail from "@/components/drawer-form/index.vue";
import { getChannelList,saveChannelRule } from "@/api/method/channel";
import { ElMessage } from "element-plus";
import FilterForm from "@/components/filter";

export default {
  name: "Theaded",
  props: ["options", "departments"],
  components: {
    FilterForm,
    TheadedTable,
    TheadedPagination,
    CustomerDetail,
  },

  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      channelId: null,
    });

    onMounted(() => {
      getList();
      channelList();
    });
    const pagination = reactive({
      page: 1,
      size: 10,
    });
    const tableData = computed(() => state.channelRuleList && state.channelRuleList.records || []);
    const total = computed(() => state.channelRuleList && state.channelRuleList.total);
    const getList = () => {
      dispatch("channelRuleList", {
        ...filterData,
        ...pagination,
      });
    };
    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    const handleSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };

    const channelList = async () => {
      const res = await getChannelList();
      filters[0][0].option = res.data.map((item) => ({
        label: item.name,
        val: item.id,
      }));
    };

    const isShowDrawer = ref(false);
    const handleDrawerClose = () => (isShowDrawer.value = false);
    const drawerId = ref(null);
    const handleNameDrawer = (row) => {
      isShowDrawer.value = true;
      drawerId.value = row.costumerId;
    };

    const saveRowData = async (row) => {
     console.log(row)

      const res = await saveChannelRule(row);
      if (res.code == 200) {
        ElMessage.success("保存成功！");
        getList();
      } else {
        ElMessage.error(res.msg);
      }
    };

    return {
      filterData,
      filters,
      handleSubmit,
      handleReset,
      tableData,
      tableColumn,
      total,
      isShowDrawer,
      handleDrawerClose,
      handleNameDrawer,
      drawerId,
      currentChange,
      sizeChange,
      pagination,
      saveRowData,
    };
  },
};
</script>

<style>
</style>
